import { isHrefLocation } from "./utils";
import { getUserResult } from "./share";

//
// fire completion pixels
//

export function trackingPixels() {
  let hasFacebookTracking = false;
  if (typeof fbq === 'function') { hasFacebookTracking = true; }

  const isGameStartPage = isHrefLocation('/start');
  const isGameInProgress = isHrefLocation('/question/') || isHrefLocation('/answer/');
  const isGameCompletePage = isHrefLocation('/complete/');

  // facebook tracking
  if (hasFacebookTracking) {
    if (isGameStartPage) { fbq('track', 'ViewContent'); }
    if (isGameStartPage) { fbq('trackCustom', 'GameStartPage'); }
    if (isGameInProgress) { fbq('trackCustom', 'GameInProgress'); }
    if (isGameCompletePage) { fbq('trackCustom', 'GameCompleted'); }
  }
}

//
// Should track result
//

const shouldTrackResult = function (event, flow) {
  if (event === 'complete_page') {
    return true;
  }

  if (['chance_page', 'nochance_page'].includes(event) && ['3', '31'].includes(flow)) {
    return true;
  }

  return false;
}

//
// Track Google Tag Manager
//

const trackGTM = function (event) {
  let bidsTTL = localStorage.getItem('bidsTTL');

  if (!bidsTTL || (bidsTTL < new Date().getTime())) {
    bidsTTL = new Date().getTime() +  (24 * 60 * 60 * 1000);
    localStorage.setItem('bidsTTL', bidsTTL);
    localStorage.removeItem('adSum');
  }

  let adSum = parseFloat(localStorage.getItem('adSum'));
  if (!adSum) {
    adSum = 0;
  }

  // rewrite event based on additional data at answer page
  if (event === 'answer_page' && document.getElementById('answer-data')) {
    event = document.getElementById('answer-data').getAttribute('data-page-type');
  }

  const f_param = Cookies.get('f_param') || '';

  const data = {
    event,
    domain: location.hostname,
    content_token: location.pathname.split("/")[3],
    f_param,
    content_item_order: Cookies.get('content_item_order') || '',
    offer_url_id: Cookies.get('offer_url_id') || '',
    ad_sum: adSum
  };

  if (Cookies.get('ap_param') === '3' && Cookies.get('hide_ap3status') === undefined) {
    data['ap3status'] = Cookies.get('ap_skip_by_bidders_ratio') === 'true' ? 'answer_disabled' : 'answer_enabled';
    if(data['ap3status'] === 'answer_disabled') {
      Cookies.set('hide_ap3status', true);
    }
  }

  if (typeof window.__tcfapi !== 'undefined') {
    __tcfapi('getTCData', 2, function (tcData, success) {
      if (success === true) {
        dataLayer.push({
          cmp_status: tcData.eventStatus + '_' + tcData.cmpStatus,
          cmp_string: tcData.tcString ? 'yes' : 'no',
        });
      }
    });
  }

  if (shouldTrackResult(event, f_param)) {
    const resultObject = getUserResult();
    data[resultObject.key] = resultObject.result;
  }

  const ua = Cookies.get('ua');
  if(ua !== undefined) {
    data['ua'] = parseInt(ua);
  }

  if (event === 'question_page') {
    const block = document.querySelector('h3.game-question')
    const variant = block.getAttribute('data-v');
    let disabledAdUnits = Cookies.get('ad_units_to_remove_from_prebid_for_tracking') ? JSON.parse(Cookies.get('ad_units_to_remove_from_prebid_for_tracking')) : undefined;

    if (!!variant) {
      data['random_question'] = variant;
    }

    if (disabledAdUnits !== undefined) {
      if (disabledAdUnits.length === 2) {
        disabledAdUnits = ['both'];
      }
      data['prebid_disabled'] = disabledAdUnits;
      Cookies.remove('ad_units_to_remove_from_prebid_for_tracking');
    }
  }

  if ('question_page' === event || 'questions_page' === event) {
    window.questionType = getQuestionType();
    data['q_type'] = window.questionType;
  }

  if (['question_page', 'answer_page'].includes(event)) {
    data['q_item'] = Cookies.get('q_item') || '';
  }

  const outbrainWidget = document.querySelector('.OUTBRAIN');
  if (outbrainWidget) {
    let outbrainWidgetId = outbrainWidget.dataset.widgetId;
    if (outbrainWidgetId.length > 0) {
      data['ob_unit'] = outbrainWidgetId;
    }
  }

  window.sessionTime = getUserSessionTime();

  if (window.sessionTime > 0) {
    data['sess_t'] = window.sessionTime;
  }

  data['case_id'] = window.__caseId;
  data['sess_id'] = window.__sessId;

  let rankingHeader = document.querySelector('.ranking-header');
  if (rankingHeader) {
    data['points_total'] = Number(rankingHeader.querySelector('.points-counter').innerText);
  }

  dataLayer.push(data);
}

//
// Track visited pages
//

export function trackPages() {
  if (isHrefLocation('/explain')) { return trackGTM('explain_page'); }
  if (isHrefLocation('/start')) { return trackGTM('start_page'); }
  if (isHrefLocation('/intro')) { return trackGTM('intro_page'); }
  if (isHrefLocation('/question')) { return trackGTM('question_page'); }
  if (isHrefLocation('/page')) { return trackGTM('questions_page'); }
  if (isHrefLocation('/answer')) { return trackGTM('answer_page'); }
  if (isHrefLocation('/break')) { return trackGTM('break_page'); }
  if (isHrefLocation('/calculating')) { return trackGTM('calculating_page'); }
  if (isHrefLocation('/chance')) { return trackGTM('chance_page'); }
  if (isHrefLocation('/no-chance')) { return trackGTM('nochance_page'); }
  if (isHrefLocation('/complete')) { return trackGTM('complete_page'); }
  if (isHrefLocation('/coming-soon')) { return trackGTM('coming_soon_page'); }
}

//
// Track orientation with GTM
//

const trackOrientationWithGTM = function(event) {
  if (event === null) { return; }

  dataLayer.push({
    orientation: event,
    domain: location.hostname,
    content_token: location.pathname.split("/")[3],
  });
};

//
// Get orientation
//

const getMobileOrientation = function() {
  if (!document.body.classList.contains('mobile')) { return null; }
  if (window.outerHeight > window.outerWidth) { return 'portrait'; }
  return 'landscape';
};


//
// Track orientation
//

export function trackOrientation() {
  if (isHrefLocation('/explain')) { return trackOrientationWithGTM(getMobileOrientation()); }
}

//
// page depth - to track how many pages user sees during the games
//

export function pageDepth() {
  let pd;
  const minPathLength = 5;
  if (location.pathname.split('/').length < minPathLength) { return; }

  const pdDefaultValue = 1;
  const nowDate = new Date();
  const isPdExpired = (localStorage.getItem('pdTTL') && (new Date(localStorage.getItem('pdTTL')).getTime() < nowDate.getTime()));

  if(!localStorage.getItem('pdTTL') || isPdExpired) {
    nowDate.setDate(nowDate.getDate() + 1);
    localStorage.setItem('pdTTL', nowDate.toUTCString());
    localStorage.setItem('pd', 0);
  }

  if (pd = localStorage.getItem('pd')) {
    pd = parseInt(pd) + 1;
    localStorage.setItem('pd', pd);
  } else {
    localStorage.setItem('pd', pdDefaultValue);
  }

  const pdCookieValue = pd || pdDefaultValue;

  document.cookie = 'pd=' + pdCookieValue + '; expires=' + localStorage.getItem('pdTTL') + '; path=/';
}

//
// GTM event when content is loaded
//

export const trackContentLoading = () => setTimeout(( () => dataLayer.push({
  event_name: 'first_page_loaded',
  domain: location.hostname,
})), 500);

//
// Track lucky spin with GTM
//

export function trackLuckySpinWithGTM(event) {
  if (event === null) { return; }

  dataLayer.push({
    lucky_spin: event,
    domain: location.hostname,
    content_token: location.pathname.split("/")[3],
  });
}

export function listenToLuckySpinEvents(App) {
  App.on('instant_win', e => trackLuckySpinWithGTM('instant_win'));
  App.on('second_chance', e => trackLuckySpinWithGTM('second_chance'));
}

export function getUserSessionTime() {
  let currentTimestampInSeconds = new Date().getTime() / 1000;
  let sessionStartTimeInSeconds = parseInt(localStorage.getItem('sessionStartTime'));

  if (!sessionStartTimeInSeconds) {
    localStorage.setItem('sessionStartTime', currentTimestampInSeconds.toString());

    return 0;
  }

  return ((currentTimestampInSeconds - sessionStartTimeInSeconds) / 5).toFixed();
}

export function trackEmailButtonWidgetLink() {
  let element = document.querySelector('.support-email-button');

  if (!element) { return; }

  dataLayer.push({
    event_name: 'contact_us_click',
  });
}

function getQuestionType() {

  if (document.querySelector('.game-answers.has-images')) {
    return 'image_answer' + document.querySelectorAll('.game-answers.has-images .has-image').length;
  }

  if (document.querySelector('.game-answer-input')) {
    return 'user_input';
  }

  return 'text' + document.querySelectorAll('.game-answers li').length;
}

export function trackPremiumFlow() {
  // IQ Premium
  if (!isHrefLocation('/premium')) { return; }

  if (
    isHrefLocation('/complete') ||
    isHrefLocation('/request-certificate') ||
    isHrefLocation('/certificate')
  ) {
    dataLayer.push({
      numericResult: Cookies.get('numericResult') || '',
      price: Cookies.get('price') || ''
    });
  }
}

export function trackEnneagramGame() {
  // Enneagram Premium
  if (!isHrefLocation('/you/NXGHC6')) { return; }

  if (
      isHrefLocation('/complete') ||
      isHrefLocation('/enneagram-result')
  ) {
    dataLayer.push({
      textResult: Cookies.get('textResult') || '',
      price: Cookies.get('price') || ''
    });
  }
}

// Internal Tracking
export function trackPageFocus() {
  let interval;

  window.secondsPageInFocus = 0;

  const start = () => interval = setInterval(() => window.secondsPageInFocus++, 1000);

  const pause = () => clearInterval(interval);

  window.onfocus = start;

  window.onblur = pause;

  start();
}

function isReloaded() {
  return performance.navigation.type === performance.navigation.TYPE_RELOAD;
}

export function trackPageLoad() {
  const meta = document.querySelector('meta[name="tracking"]');

  if (!meta) { return; }

  sendTracking(meta.dataset);

  trackHasOffersIneligible(meta.dataset);
  trackPageAdvance();

  meta.remove();
}

function getPageLoadData(tracking, timeInMilliseconds = false) {
  return {
    type: 'page_load',
    data: [
      tracking.hash,
      tracking.language,
      tracking.subdomain,
      tracking.device,
      window.__uuid,
      timeInMilliseconds ? tracking.serverTimeMilliseconds : tracking.serverTime,
      timeInMilliseconds ? getClientTimeOffsetInMilliseconds(tracking.serverTimeMilliseconds) : getClientTimeOffset(tracking.serverTime),
      tracking.sessionId,
      tracking.offerUrlId,
      tracking.country,
      tracking.flow,
      tracking.extId,
      tracking.resultToken,
      tracking.page,
      isReloaded(),
    ]
  }
}

function getUserResultData(tracking, timeInMilliseconds = false) {
  return {
    type: 'user_result',
    data: [
      timeInMilliseconds ? parseInt(tracking.serverTimeMilliseconds) : tracking.serverTime,
      tracking.productToken,
      tracking.sessionId,
      window.__uuid,
      tracking.contentType,
      tracking.resultNumber,
      tracking.resultText,
      tracking.resultToken,
    ]
  }
}

function getSessionData(tracking, timeInMilliseconds = false) {
  return {
    type: 'session_start',
    data: [
      tracking.sessionId,
      timeInMilliseconds ? (parseInt(Cookies.get('session_created_at')) * 1000 || '') : (Cookies.get('session_created_at') || ''),
      Cookies.get('referrer') || '',
      tracking.browserName,
      tracking.browserVersion,
      navigator.language,
      tracking.osName,
      tracking.osVersion,
      tracking.deviceModel,
      getResolution(),
      getOrientation(),
      tracking.country,
      tracking.offerUrlId,
      tracking.extId,
      tracking.productToken,
      tracking.flow,
      tracking.device
    ]
  }
}

function getOrientation() {
  if (matchMedia('(orientation: landscape)').matches) {
    return 'landscape'
  }

  if (matchMedia('(orientation: portrait)').matches) {
    return 'portrait'
  }

  return ''
}

function getResolution() {
  return `${window.screen.width * window.devicePixelRatio}x${window.screen.height * window.devicePixelRatio}`
}

function trackPageAdvance() {
  trackHeader();
  trackCrossSell();
  trackNext();
  trackAnswer();
  trackFooter();
}

function trackHeader() {
  document
    .querySelectorAll('header a[href]:not([href=""]):not([href="#"])')
    .forEach(link => link.addEventListener('click', event => savePageAdvance(event, 'header_link')))
}

function trackNext() {
  const pagesWithNextButton = 'start|intro|explain|answer|break|certificate|page|complete';

  if (! new RegExp(pagesWithNextButton).test(window.location.href)) { return }

  trackDelayed('.btn:not(.pt-download):not(.save-answer):not(.send-answers):not(span)', 'next')
}

function trackCrossSell() {
  trackDelayed('[data-widget="xsell"] a', 'cross_sell')
}

function trackAnswer() {
  if (!isHrefLocation('/question/')) { return; }

  trackDelayed('.game-answers a', 'answer')

  trackDelayed('button[type="submit"]', 'answer')
}

function trackDelayed(selector, source) {
  let interval = setInterval(() => {
    let elements = document.querySelectorAll(selector);

    if (!elements.length) { return; }

    elements.forEach(link => link.addEventListener('click', event => savePageAdvance(event, source)))

    clearInterval(interval);
  }, 1000);
}

function trackFooter() {
  document
    .querySelectorAll('footer a[href]:not([href=""]):not([href="#"])')
    .forEach(link => link.addEventListener('click', event => savePageAdvance(event, 'footer_link')))
}

function getPageAdvanceData(source, timeInMilliseconds = false) {
  return {
    type: 'page_advance',
    data: [window.__uuid, timeInMilliseconds ? getTimestampInMilliseconds() : getTimestamp(), window.secondsPageInFocus, source],
  }
}

function getClientTimeOffset(serverTime) {
  return getTimestamp() - serverTime;
}

function getClientTimeOffsetInMilliseconds(serverTime) {
  return getTimestampInMilliseconds() - serverTime;
}

function getTimestamp() {
  return Math.floor(Date.now() / 1000);
}

function getTimestampInMilliseconds() {
  return Date.now();
}

function savePageAdvance(event, source) {
  localStorage.setItem('page_advance', JSON.stringify(getPageAdvanceData(source)))
  localStorage.setItem('page_advance_ms', JSON.stringify(getPageAdvanceData(source, true)))
}

function sendTracking(tracking) {
  return new Promise((resolve, reject) => {
    try {
      let client = new StompJs.Client({
        brokerURL: tracking.brokerUrl,
        reconnectDelay: 0,
        heartbeatIncoming: 0,
        heartbeatOutgoing: 0
      });

      client.onConnect = function (frame) {
        if (Cookies.get('session_created_at')) {
          sendDataToKafka(getSessionData(tracking, true).data, 'session');
          client.publish({
            destination: tracking.sessionQueue,
            headers: { persistent: true },
            body: JSON.stringify(getSessionData(tracking))
          });

          Cookies.remove('session_created_at');
          Cookies.remove('referrer');
        }

        if (localStorage.getItem('page_advance')) {
          sendDataToKafka(JSON.parse(localStorage.getItem('page_advance_ms')).data, 'page_advance');
          client.publish({
            destination: tracking.trackingQueue,
            headers: { persistent: true },
            body: localStorage.getItem('page_advance')
          });

          localStorage.removeItem('page_advance');
          localStorage.removeItem('page_advance_ms');
        }

        sendDataToKafka(getPageLoadData(tracking, true).data, 'page_load');
        client.publish({
          destination: tracking.trackingQueue,
          headers: { persistent: true },
          body: JSON.stringify(getPageLoadData(tracking))
        });

        if (isHrefLocation('/complete')) {
          sendDataToKafka(getUserResultData(tracking, true).data, 'results');
          client.publish({
            destination: tracking.userResultQueue,
            headers: { persistent: true },
            body: JSON.stringify(getUserResultData(tracking))
          });
        }

        client.deactivate();

        resolve();
      };

      client.onStompError = function (frame) {
        reject();
      };

      client.activate();
    } catch (error) {
      reject(error);
      console.log(error)
    }
  });
}

function trackHasOffersIneligible(tracking)
{
  const trackingEvent = 'ho_conv_ineligible';
  let _hoIneligible = Cookies.get(trackingEvent);
  if (!_hoIneligible) { return; }

  let _hoIneligibleData = _hoIneligible.split(':');
  let _timestamp = _hoIneligibleData.length > 0 ? _hoIneligibleData[0] : null;
  let _transaction = (_hoIneligibleData.length > 1 && !!_hoIneligibleData[1].length) ? _hoIneligibleData[1] : null;
  let _reason = _hoIneligibleData.length > 2 ? _hoIneligibleData[2] : null;
  let _details = (_hoIneligibleData.length > 3  && !!_hoIneligibleData[3].length) ? _hoIneligibleData[3] : null;

  sendDataToKafka(
    [
      parseInt(_timestamp),
      tracking.sessionId,
      _transaction,
      _reason,
      _details,
      window.__uuid
    ],
    trackingEvent
  );

  Cookies.remove(trackingEvent);
}

export function trackKeyGameEvents()
{
  const keyGameEvents = ['game_start', 'game_end', 'conversion'];
  let _gameEvents = [];
  keyGameEvents.forEach((e) => {
    if (!!Cookies.get(e)) {
      _gameEvents.push({
        type: e,
        data: Cookies.get(e)
      });
    }
  });

  if (!_gameEvents.length) return;

  _gameEvents.forEach((e) => {
    let _data = e.data.split(':');
    Cookies.remove(e.type);

    sendDataToKafka(
        [
          parseInt(_data[0]), // timestamp
          _data[1], // session_id
          !!_data[2].length ? _data[2] : null, // offer_url_id
          _data[3], // content_token
          e.type, // event_type
          !!_data[4].length ? _data[4] : null, // transaction_id
        ],
        'start_end'
    );
  });
}

export function interPageAdsTracking() {
  document.addEventListener('track_rewarded_slots', function(event) {
      let _index = null;

      dataLayer.forEach((item, index) => {
        if (item.hasOwnProperty('rewarded') && item.hasOwnProperty('interstitial')) {
          _index = index;
        }
      });

      if (!!_index) {
        dataLayer.splice(_index, 1);
      }

      dataLayer.push({
          rewarded: window._interPageAds.rewarded,
          interstitial: window._interPageAds.interstitial,
      });

    if (event.detail !== null && event.detail.cnFallback !== undefined) {
      dataLayer.push({
        cn_fallback: event.detail.cnFallback
      });
    }
  });
}